import { useState } from 'react';

import { UseFormReturn } from 'react-hook-form';
import { IProgramSetup, IProgramSetupForm } from 'shared/interfaces/IProgramSetup';
import { ProgramSetupContainer } from './ProgramSetup.styled';
import {
  ProgramSetupPageSearchLoading,
  ProgramSetupPageSearchOptions,
  ProgramSetupSearch,
} from './ProgramSetupContainer';
import { ProgramSetupDetails, ProgramSetupAnchors, ProgramSetupRecording } from './ProgramSetupDetails';
import { ProgramSetupTimeslot } from './ProgramSetupTimeslot';
import { ErrorBanner } from './components/ErrorBanner';
import { StepRail, Step } from './components/StepRail';

interface Props {
  form: UseFormReturn<IProgramSetupForm, object>;
  programSetup?: IProgramSetup;
  options: ProgramSetupPageSearchOptions;
  searchLoading: ProgramSetupPageSearchLoading;
  onSearch: (key: keyof ProgramSetupSearch, value: any) => void;
  isLoading?: boolean;
}

// Matches the prototype's rail exactly (Program → Anchors → Recording → Schedule).
const STEPS: Step[] = [
  { id: 'secDetails', label: 'Program' },
  { id: 'secAnchors', label: 'Anchors' },
  { id: 'secRecording', label: 'Recording' },
  { id: 'secSchedule', label: 'Schedule' },
];

export const ProgramSetupView = ({ form, options, searchLoading, onSearch, isLoading, programSetup }: Props) => {
  const { formState } = form;
  const [activeStep, setActiveStep] = useState<string>(STEPS[0].id);

  const goToStep = (id: string) => {
    setActiveStep(id);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const sharedProps = { form, options, searchLoading, onSearch, isLoading, programSetup };

  return (
    <ProgramSetupContainer className="ps-redesign">
      <StepRail steps={STEPS} active={activeStep} onGo={goToStep} />

      <ErrorBanner errors={formState.errors} />

      <ProgramSetupDetails {...sharedProps} />
      <ProgramSetupAnchors {...sharedProps} />
      <ProgramSetupRecording {...sharedProps} />
      <ProgramSetupTimeslot form={form} isLoading={isLoading} />
    </ProgramSetupContainer>
  );
};
